import { Chart, type ChartProps } from "./Chart"
import { useChartConfigById } from "./hooks/useChartConfigById"

type ChartWithConfigIdProps = Omit<ChartProps, "config"> & {
  id: string
}
export function ChartWithConfigId({ id, ...props }: ChartWithConfigIdProps) {
  const config = useChartConfigById(id)

  return <Chart key={id} config={config} {...props} />
}
